// extracted by mini-css-extract-plugin
export var buttonsRow = "ShareCard-module--buttonsRow--6d4ba";
export var closeIcon = "ShareCard-module--closeIcon--bef82";
export var icon = "ShareCard-module--icon--56634";
export var linkContainer = "ShareCard-module--linkContainer--61afb";
export var linkSpan = "ShareCard-module--linkSpan--b64e1";
export var shareCardContainer = "ShareCard-module--shareCardContainer--d57ba";
export var shareCardTitle = "ShareCard-module--shareCardTitle--52ff3";